"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MockUserDataService = /** @class */ (function () {
    function MockUserDataService() {
        this._map = {};
    }
    MockUserDataService.prototype.listUserData = function () {
        var _this = this;
        var keys = Object.keys(this._map);
        var data = keys.map(function (key) {
            return _this._map[key];
        });
        return Promise.resolve(data);
    };
    MockUserDataService.prototype.getUserData = function (request) {
        return Promise.resolve(this._map[request.key]);
    };
    MockUserDataService.prototype.setUserData = function (data) {
        this._map[data.key] = data;
        return Promise.resolve(Object.assign({}, data));
    };
    MockUserDataService.prototype.deleteUserData = function (data) {
        delete this._map[data.key];
        return Promise.resolve();
    };
    return MockUserDataService;
}());
exports.MockUserDataService = MockUserDataService;
